import store from '../store';
import { setDialog } from '../actions/dialog';


export default () => store.dispatch(
  setDialog({
    name: 'VerficationProp',
    open: true,
    hideClose: true,
    dialogProps: {
      title: 'Information',
      middle: true,
      fullScreenOn: false,
    },
    contentProps: {
      message:
        'Une nouvelle version est disponible, ' +
        'Mise à jour en cours . Veuillez patienter',
    },
  })
);
